function OrderedList (container, dispElem){
	this.elem = ge(container)||null;
	this.dispElem = dispElem||'elem';

	this.reOrderOb = null;

	this.i = 0;
	this.items = [];
	this.shifting = 0;
}

//noinspection JSUnusedGlobalSymbols
OrderedList.prototype = {
	addItem : function(obj, orderby){
		orderby=orderby||null;
		if (orderby
			&& obj.hasOwnProperty(orderby)){
			for (var i = 0; i < this.items.length;i++){
				if (obj[orderby] <= this.items[i][orderby]){
					if(this.elem) this.elem.insertBefore(
						obj[this.dispElem],
						this.items[i][this.dispElem]
					);
					this.items.splice(i,0,obj);
					return;
				}
			}
		}
		this.items.push(obj);
		if (this.elem) this.elem.appendChild(obj[this.dispElem]);
	},
	reset: function() {
		this.i = -1;
		return this.items.length > 0;
	},
	seek : function(i){
		if (i < 0 || i >= this.items.length) return false;
		this.i = i;
		return this.items[i];
	},
	getPos : function(){
		return this.i;
	},
	moveFirst: function () {
		if (this.items.length) {
			this.i = 0;
			return true;
		}
		return false;
	},
    moveNext : function(){
        if (this.i+1 < this.items.length) {
            this.i++;
            return true;
        }
        return false;
    },
	getIndex : function(obj){
		if(typeof(obj) === 'object'){
			return this.items.indexOf(obj);
		} else {
			return -1;
		}
	},
	getItemById : function(id){
		for (var i = 0; i < this.items.length; i++){
			if (this.items[i].id === parseInt(id)) return this.items[i];
		}
		return false;
	},
	getItem : function(){
		if (this.items.length && this.i < this.items.length) return this.items[this.i];
		return false;
	},
	getPrev : function(){
		if (this.i === 0) return false;
		return this.items[this.i-1];
	},
	getNext : function(){
		if (this.i === this.items.length-1) return false;
		return this.items[this.i+1];
	},
	removeItemByIndex : function(i){
		i = (typeof(i) === 'number') ? i : this.items.length - 1;
		if (this.elem) this.elem.removeChild(this.items[i][this.dispElem]);
		return this.items.splice(i,1)[0];
	},
	removeItemById : function(id){
		for (var i = 0; i < this.items.length; i++) {
			if (this.items[i].id === id) {
				return this.removeItemByIndex(i);
			}
		}
	},
	removeItem : function(obj){
		if (typeof(obj) === 'object'){
			this.removeItemByIndex(this.items.indexOf(obj));
		}
	},
	clear : function(){
		while(this.items.length){
			this.removeItemByIndex(0);
		}
	},
	setContainerElement : function (element){
		this.elem = element;
		for (var i=0;i<this.items.length;i++) this.elem.appendChild(this.items[i][this.dispElem]);
	},
	getLength : function(){
		return this.items.length;
	},
	length : function(){
		return this.items.length;
	},
	prepReOrder: function(ob, ev) {
		if (!ob.dragElem) return;
		style(ob.dragElem, 'hiLt');
		startDrag(ev, this);
		this.curInElem = pointInElem(ob[this.dispElem]);
		ob[this.dispElem].style.height = ob.dragElem.offsetHeight + 'px';
		ob.dragElem.style.width = ob[this.dispElem].offsetWidth + 'px';
		document.body.appendChild(ob.dragElem);
		this.reOrderOb = ob;
		this.positonDragElem();
	},
	drag: function(ev){
		// drag function to be call if the list is passed to the drag operation
		this.positionByDragging(this.reOrderOb);
		this.positonDragElem();
		if (this.reOrderOb.drag) this.reOrderOb.drag(ev);
	},
	positionByDragging : function(obj){
		// obj is the item to move
		// x,y are the coordinate from the event
		// return new position in the list
		if (this.shifting) return;
		var i = this.items.indexOf(obj);
		var pnt = pointInElem(obj[this.dispElem]);
		if (pnt.y < 0 && i > 0) {
			this.moveUp(i);
		} else if (pnt.y > obj[this.dispElem].offsetHeight && i < (this.items.length - 1)){
			this.moveDn(i);
		}
		obj.newOrderBy =  i + 1;
	},
	positonDragElem: function(){
		this.reOrderOb.dragElem.style.left = pointB.x - this.curInElem.x + 'px';
		this.reOrderOb.dragElem.style.top = pointB.y - this.curInElem.y + 'px';
	},
	reattach: function(){
		style(this.reOrderOb.dragElem);
		this.reOrderOb[this.dispElem].appendChild(this.reOrderOb.dragElem);
		this.reOrderOb[this.dispElem].style.height = 'auto';
		this.reOrderOb.dragElem.style.left = '0px';
		this.reOrderOb.dragElem.style.top = '0px';
		this.reOrderOb.dragElem.style.width = '100%';
	},
	clicked: function (ev) {
		this.reattach();
		if (this.reOrderOb.clicked) this.reOrderOb.clicked(ev);
	},
	dropped: function (ev) {
		this.reattach();
		if (this.reOrderOb.dropped) {
			this.reOrderOb.dropped(ev);
		}
		else {
			if (this.reOrderOb.newOrderBy !== this.reOrderOb.orderBy) this.reOrderOb.save();
		}
	},
	moveUp : function(n){
		n = typeof(n) === 'undefined' ? this.i : n;
		if (n<=0) return;
		this.shifting = 1;
		this.elem.insertBefore(
			this.elem.removeChild(this.items[n][this.dispElem].previousSibling),
			this.items[n][this.dispElem].nextSibling
		);

		this.items.splice(n--,0,this.items.splice(n,1)[0]);
		this.shifting = 0;
		return this.i = n;
	},
	moveDn : function(n){
		n = typeof(n) === 'undefined' ? this.i : n;
		if (n>=this.items.length-1) return;
		this.shifting = 1;
		this.elem.insertBefore(
			this.elem.removeChild(this.items[n][this.dispElem].nextSibling),
			this.items[n][this.dispElem]
		);

		this.items.splice(n++,0,this.items.splice(n,1)[0]);
		this.shifting = 0;
		return this.i = n;
	},
	reOrder : function(){
		for (var i = 0; i < this.items.length; i++) {
			if (typeof(this.items[i].setPosition) === 'function')
				this.items[i].setPosition(i+1);
		}
	},
	showSaving : function(){
		style(this.elem,'loading');
	},
	hideSaving : function(){
		style(this.elem,'norm');
	}
};